import { render, staticRenderFns } from "./ListBuyerCampaigns.vue?vue&type=template&id=2968bf1e"
import script from "./ListBuyerCampaigns.vue?vue&type=script&lang=js"
export * from "./ListBuyerCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports